var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProviderBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#2F2B32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5768 15.4569V17.1379L10.1112 18L8.68883 17.1379V15.4569L10.1112 16.319L11.5768 15.4569ZM3.73193 9.63793L5.15435 10.5V13.3879L7.61124 14.8534V16.5345L3.73193 14.25V9.63793ZM16.4905 9.63793V14.25L12.5681 16.5345V14.8534L15.025 13.3879V10.5L16.4905 9.63793V9.63793ZM12.5681 7.35345L14.0337 8.21552V9.89655L11.5768 11.3621V14.2931L10.1543 15.1552L8.73193 14.2931V11.3621L6.18883 9.89655V8.21552L7.65435 7.35345L10.1112 8.81896L12.5681 7.35345V7.35345ZM6.18883 11.1034L7.61124 11.9655V13.6465L6.18883 12.7845V11.1034ZM14.0337 11.1034V12.7845L12.6112 13.6465V11.9655L14.0337 11.1034ZM5.15435 5.88793L6.61986 6.75L5.15435 7.61207V9.2931L3.73193 8.43103V6.75L5.15435 5.88793V5.88793ZM15.0681 5.88793L16.5337 6.75V8.43103L15.0681 9.2931V7.61207L13.6457 6.75L15.0681 5.88793V5.88793ZM10.1112 5.88793L11.5768 6.75L10.1112 7.61207L8.68883 6.75L10.1112 5.88793V5.88793ZM10.1112 3L14.0337 5.28448L12.6112 6.14655L10.1543 4.68103L7.65435 6.14655L6.23193 5.28448L10.1112 3V3Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderBsc);
export default __webpack_public_path__ + "static/media/provider-bsc.db2a3f571a3e7fe0ccddf2a5b31f348a.svg";
export { ForwardRef as ReactComponent };